import React from 'react';
import './KofiLink.css';

export default function KofiLink() {
  return (
    <a 
      href="https://ko-fi.com/urnotniche" 
      target="_blank" 
      rel="noopener noreferrer"
      className="kofi-link"
    >
      support me
    </a>
  );
}
